import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ text }) => {
  if (!text) {
    text = 'Loading...';
  }

  return (
    <span className="loading-widget">
      <i className="loading-icon fa fa-spinner fa-spin" aria-hidden="true" />
      <span>{text}</span>
    </span>
  );
};

Loading.propTypes = {
  text: PropTypes.string,
};

export default Loading;
